import { ImageWithOptionalText } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'

/**
 * Creates a mock ImageWithOptionalText
 * @param overrides - Partial fields to override defaults
 * @returns Complete ImageWithOptionalText mock
 */
export function createImageWithOptionalText(
  overrides: Partial<ImageWithOptionalText> = {}
): ImageWithOptionalText {
  return {
    _uid: 'e4daf73b-71f4-46a3-8d25-0d401bf01c7c',
    image: createStoryblokAsset({
      id: 9757937,
      filename:
        'https://a.storyblok.com/f/235453/1920x445/0868c8320d/filiale.jpg',
      src: 'https://a.storyblok.com/f/235453/1920x445/0868c8320d/filiale.jpg',
      width: 1920,
      height: 445,
      aspect_ratio: 4.31,
      content_type: 'image/jpeg',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    subline: 'subline asdsadsd asdsda asdsasd asdsa',
    headline: 'headline',
    component: 'image-with-optional-text',
    _editable:
      '<!--#storyblok#{"name": "image-with-optional-text", "space": "235453", "uid": "e4daf73b-71f4-46a3-8d25-0d401bf01c7c", "id": "322787899"}-->',
    ...overrides,
  }
}
